module.exports = __webpack_public_path__ + "img/quizicon500x500line.4289fb65.png";